import {Employer} from "../../models/users/Employee";
import {Office, OfficeList} from "../../models/common/Office";
import {
    errorFetchingRequestState,
    getInitialRequestState,
    RequestState,
    startFetchingRequestState,
    successFetchingRequestState
} from "../../models/common/RequestState";
import {Nullable} from "../../models/common/Nullable";
import {
    CREATE_EMPLOYER,
    CREATE_EMPLOYER_ERROR,
    CREATE_EMPLOYER_SUCCESS,
    DELETE_EMPLOYER,
    DELETE_EMPLOYER_ERROR, DELETE_EMPLOYER_SUCCESS,
    EmployersActionTypes,
    FETCH_EMPLOYER_BY_ID,
    FETCH_EMPLOYER_BY_ID_ERROR,
    FETCH_EMPLOYER_BY_ID_SUCCESS,
    FETCH_EMPLOYERS,
    FETCH_EMPLOYERS_ERROR,
    FETCH_EMPLOYERS_SUCCESS,
    RESTORE_EMPLOYER,
    RESTORE_EMPLOYER_ERROR,
    RESTORE_EMPLOYER_SUCCESS,
    UPDATE_EMPLOYER,
    UPDATE_EMPLOYER_ERROR, UPDATE_EMPLOYER_SUCCESS
} from "../../actions/employees/EmployerActions";
import {
    FETCH_EMPLOYERS_OFFICES,
    FETCH_EMPLOYERS_OFFICES_ERROR,
    FETCH_EMPLOYERS_OFFICES_SUCCESS,
    FetchEmployerOfficesActionTypes
} from "../../actions/employees/EmployersOfficeActions";
import {BasicDetailReducerState, BasicListReducerStateType} from "../BasicReducerState";
import {CREATE_EMPLOYEE} from "../../actions/employees/EmployeeActions";


export interface EmployersState {
    employers: BasicListReducerStateType< Nullable< Employer[] > >
    detailedEntries: BasicDetailReducerState< Nullable< Employer > >
    offices: OfficeList
    request: RequestState
}

const initialState: EmployersState = {
    employers: {
        entries: {
            current: null,
            request: getInitialRequestState()
        },
        totalEntries: 0
    },
    detailedEntries: {},
    offices: {},
    request: getInitialRequestState()
};

export function EmployersReducer(
    state = initialState,
    action: EmployersActionTypes | FetchEmployerOfficesActionTypes
): EmployersState {

    switch( action.type ) {

        case FETCH_EMPLOYERS:
            return {
                ...state,
                employers: {
                    entries: {
                        current: [],
                        request: startFetchingRequestState()
                    },
                    totalEntries: 0
                }
            };
        case FETCH_EMPLOYERS_SUCCESS:
            return {
                ...state,
                employers: {
                    ...state.employers,
                    entries: {
                        current: action.payload.entries,
                        request: successFetchingRequestState()
                    },
                    totalEntries: action.payload.totalEntries
                },
            };
        case FETCH_EMPLOYERS_ERROR:
            return {
                ...state,
                employers: {
                    ...state.employers,
                    entries: {
                       ...state.employers.entries,
                        request: errorFetchingRequestState( action.error )
                    },
                }
            };
        case FETCH_EMPLOYER_BY_ID:
            return {
                ...state,
                detailedEntries: {
                    ...state.detailedEntries,
                    [ action.employerId.rawValue ]: {
                        entry: null,
                        request: startFetchingRequestState()
                    },

                }
            };
        case FETCH_EMPLOYER_BY_ID_SUCCESS:
            return {
                ...state,
                detailedEntries: {
                    ...state.detailedEntries,
                    [ action.employer.employersId.rawValue ]: {
                        entry: action.employer,
                        request: successFetchingRequestState()
                    },

                }
            };
        case FETCH_EMPLOYER_BY_ID_ERROR:
            return {
                ...state,
                detailedEntries: {
                    ...state.detailedEntries,
                    [ action.employerId.rawValue ]: {
                        entry: null,
                        request: errorFetchingRequestState( action.error )
                    }
                }
            };
        case UPDATE_EMPLOYER:
        case DELETE_EMPLOYER:
        case RESTORE_EMPLOYER:
        case CREATE_EMPLOYER:
            return {
                ...state,
                request: startFetchingRequestState()
            };
        case UPDATE_EMPLOYER_SUCCESS:
        case DELETE_EMPLOYER_SUCCESS:
        case RESTORE_EMPLOYER_SUCCESS:
        case CREATE_EMPLOYER_SUCCESS:
            return {
                ...state,
                request: successFetchingRequestState()
            };
        case UPDATE_EMPLOYER_ERROR:
        case DELETE_EMPLOYER_ERROR:
        case RESTORE_EMPLOYER_ERROR:
        case CREATE_EMPLOYER_ERROR:
            return {
                ...state,
                request: errorFetchingRequestState( action.error )
            };
        case FETCH_EMPLOYERS_OFFICES:
            return {
                ...state,
                request: {
                    lastRequestSuccess: 0,
                    error: null,
                    isFetching: true
                }
            };
        case FETCH_EMPLOYERS_OFFICES_SUCCESS:
            return {
                ...state,
                offices: officesToObject(action.payload.entries),
                request: {
                    lastRequestSuccess: Date.now(),
                    error: null,
                    isFetching: false
                }
            };
        case FETCH_EMPLOYERS_OFFICES_ERROR:
            return {
                ...state,
                request: {
                    ...state.request,
                    error: action.error,
                    isFetching: false
                }
            };
        default:
            return state;
    }

}

const officesToObject = ( offices: Office[] ) => {
    let object: OfficeList = {};

    offices.forEach( office => {
        object = {
            ...object,
            [ office.officeId.rawValue ]: office
        };
    });

    return object;
};